export default __webpack_public_path__ + "static/media/laconic_mobile_small@2x.8036b8da.jpg";